import "./FAQAccordionSection.scss";
import Accordion from "./components/Accordion.js";
import tagSvg from '../../../../assets/images/WhoWeHelp/tag.svg';
function FAQAccordionSection({ faqData, title }) {
    return (
        <>
        <hr className="section-divider" />
            <div className="faq-accordion-section">
                <div className='common-section-content text'>
                    <div className='tag' style={{
                        backgroundImage: `url(${tagSvg})`,
                    }}>
                        <span>FAQ</span>
                    </div>
                    <br />
                    <h1>Frequently Asked Questions</h1>
                </div>
                <div className='common-section-content'>
                    {faqData.map((item) => (
                        <Accordion title={item.question} description={item.answer} />
                    ))}
                </div>
            </div>
                <hr className="section-divider" />
            {/* <div className="container">
                <div className="accordion">
                    <h1 className="accordion__heading">
                       FAQs
                    </h1>
                    {faqDataForCommon.map((item) => (
                        <Accordion title={item.question} description={item.answer} />
                    ))}
                </div>
            </div> */}
        </>
    );
}

export default FAQAccordionSection;